import { render, staticRenderFns } from "./extra-field-modal.vue?vue&type=template&id=5a96ec41&scoped=true"
import script from "./extra-field-modal.vue?vue&type=script&lang=js"
export * from "./extra-field-modal.vue?vue&type=script&lang=js"
import style0 from "./extra-field-modal.vue?vue&type=style&index=0&id=5a96ec41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96ec41",
  null
  
)

export default component.exports